import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import api from "@/api/bi";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async reportList(params: any) {
    return api.reportList(params);
  }

  @Action
  async reportDetail(params: any) {
    return api.reportDetail(params);
  }

  @Action
  async reportDetailExport(params: any) {
    return api.reportDetailExport(params);
  }

  @Action
  async rowDetailList(params: any) {
    return api.rowDetailList(params);
  }

  @Action
  async exportRowDetailList(params: any) {
    return api.exportRowDetailList(params);
  }

  @Action
  async excelBalance(params: any) {
    return api.excelBalance(params);
  }

  @Action
  async excelRefund(params: any) {
    return api.excelRefund(params);
  }

  @Action
  async excelIncome(params: any) {
    return api.excelIncome(params);
  }

  @Action
  async excelExpire(params: any) {
    return api.excelExpire(params);
  }
  @Action
  async settlement(params: any){
    return api.settlement(params);
  }
}
